import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SectionTitle from '../../components/SectionTitle';
import SingleTeamThree from '../../components/Team/SingleTeamThree';
import DataState from '../../components/DataState';
import { staffByDepartment } from '../../data';
import { useCollections } from '../../lib/api/collections';
import { personPhoto } from '../../data/images';



// mode "leadership" shows the Board of Directors; otherwise staff grouped by department.
const TeacherMain = ({ mode }) => {
  const content = useCollections('staff', 'board');
  if (content.loading || content.error) return <DataState state={content} />;
  const { staff } = content;
  const board = content.board.board;

  const groups =
    mode === 'leadership'
      ? [
          {
            title: 'Board of Directors',
            eyebrow: 'Leadership',
            people: board.map((b, i) => ({ name: b.displayName, photo: b, rank: b.rank, to: i === 0 ? '/chairman' : undefined })),
          },
        ]
      : staffByDepartment(staff).map((g) => ({
          title: g.dept,
          eyebrow: 'Our Staff',
          people: g.people.map((p) => ({ name: p.displayName, photo: p, rank: p.rank })),
        }));

  return (
    <main>
      <Breadcrumb
        title={mode === 'leadership' ? 'Leadership' : 'Our Staff'}
        subTitle={mode === 'leadership' ? 'Leadership' : 'Staff'}
      />

      {groups.map((group, g) => (
        <div
          key={group.title}
          className={
            g === 0
              ? 'ed-team-area p-relative inner-style fix z-index pt-110 pb-90'
              : 'ed-team-area p-relative inner-style fix z-index pt-0 pb-90'
          }
        >
          <div className="container">
            <div className="it-team-title-wrap mb-40">
              <div className="row align-items-center justify-content-center">
                <div className="col-xl-6">
                  <SectionTitle
                    itemClass="it-team-title-box text-center"
                    subTitleClass="ed-section-subtitle"
                    subTitle={group.eyebrow}
                    titleClass="ed-section-title"
                    title={group.title}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              {group.people.map((p) => (
                <div
                  key={p.name}
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30"
                >
                  <SingleTeamThree
                    teamImage={personPhoto(p.photo)}
                    authorName={p.name}
                    designation={p.rank}
                    to={p.to}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </main>
  );
};
export default TeacherMain;
